module.exports = __webpack_public_path__ + "img/logo.924536b7.png";